var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCurveUpGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3952_29267",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3952_29267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.35415 14.3535C2.22915 14.2285 2.16999 14.0827 2.17665 13.916C2.18388 13.7493 2.24304 13.6035 2.35415 13.4785L7.27082 8.52018C7.34026 8.45074 7.41999 8.39852 7.50999 8.36352C7.60054 8.32907 7.69443 8.31185 7.79165 8.31185C7.88888 8.31185 7.98276 8.32907 8.07332 8.36352C8.16332 8.39852 8.24304 8.45074 8.31249 8.52018L11.125 11.3327L15.9792 6.54102H14.125C13.9444 6.54102 13.7953 6.48185 13.6775 6.36352C13.5592 6.24574 13.5 6.09657 13.5 5.91602C13.5 5.73546 13.5592 5.58602 13.6775 5.46768C13.7953 5.3499 13.9444 5.29102 14.125 5.29102H17.3333C17.5417 5.29102 17.7189 5.36379 17.865 5.50935C18.0105 5.65546 18.0833 5.83268 18.0833 6.04102V9.24935C18.0833 9.4299 18.0244 9.57907 17.9067 9.69685C17.7883 9.81518 17.6389 9.87435 17.4583 9.87435C17.2778 9.87435 17.1286 9.81518 17.0108 9.69685C16.8925 9.57907 16.8333 9.4299 16.8333 9.24935V7.41602L11.6458 12.6035C11.5764 12.673 11.4967 12.7249 11.4067 12.7593C11.3161 12.7943 11.2222 12.8118 11.125 12.8118C11.0278 12.8118 10.9342 12.7943 10.8442 12.7593C10.7536 12.7249 10.6736 12.673 10.6042 12.6035L7.79165 9.79102L3.20832 14.3743C3.09721 14.4855 2.95832 14.541 2.79165 14.541C2.62499 14.541 2.47915 14.4785 2.35415 14.3535Z",
    fill: "#1DA687"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurveUpGreen);
export default __webpack_public_path__ + "static/media/arrow_curve_up_green.6089ec925a2129cfb96c25ef6a2a4e69.svg";
export { ForwardRef as ReactComponent };